module.exports = __webpack_public_path__ + "img/ico_power.52c6616a.png";